import { type ClassValue, clsx } from 'clsx'
import { format } from 'date-fns'
import { cs } from 'date-fns/locale'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatShortDate(date: Date): string {
  return format(date, 'd. M.', { locale: cs })
}

const dayOfWeekShort = ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So']

export function formatDate(date: Date, showDayOfWeek: boolean = false): string {
  const formatted = format(date, 'd. M. yyyy', { locale: cs })
  return showDayOfWeek ? `${dayOfWeekShort[date.getDay()]} ${formatted}` : formatted
}

/**
 * Returns Czech plural form for "night" (noc/noci/nocí)
 */
export function getNightsLabel(nights: number): string {
  if (nights === 1) return 'noc'
  if (nights >= 2 && nights <= 4) return 'noci'
  return 'nocí'
}

/**
 * Returns Czech plural form for "day" (den/dny/dní)
 */
export function getDaysLabel(days: number): string {
  if (days === 1) return 'den'
  if (days >= 2 && days <= 4) return 'dny'
  return 'dní'
}

/**
 * Formats nights count with proper Czech plural (e.g., "3 noci")
 */
export function formatNights(nights: number): string {
  return `${nights} ${getNightsLabel(nights)}`
}

/**
 * Returns Czech plural form for "person" (osoba/osoby/osob)
 */
export function getPersonsLabel(persons: number): string {
  if (persons === 1) return 'osoba'
  if (persons >= 2 && persons <= 4) return 'osoby'
  return 'osob'
}

/**
 * Returns Czech plural form for "crib" (postýlka/postýlky/postýlek)
 */
export function getCribsLabel(cribs: number): string {
  if (cribs === 1) return 'postýlka'
  if (cribs >= 2 && cribs <= 4) return 'postýlky'
  return 'postýlek'
}
